var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { title: _vm.$t("lbl_good_receipt_checklist") } },
    [
      _c(
        "a-form",
        _vm._b(
          {
            attrs: { form: _vm.form },
            nativeOn: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.findItems(false)
              }
            }
          },
          "a-form",
          _vm.formItemLayout,
          false
        ),
        [
          _c(
            "a-row",
            { attrs: { gutter: [16, 16] } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "label-align": "left",
                        label: _vm.$t(_vm.formRules.goodReceiptNumber.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.goodReceiptNumber.decorator,
                              expression:
                                "formRules.goodReceiptNumber.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.goodReceiptNumber.name,
                            placeholder: _vm.$t(
                              _vm.formRules.goodReceiptNumber.placeholder
                            ),
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loadingGRNumber,
                            allowClear: true
                          },
                          on: { search: _vm.onSearchGrNumber }
                        },
                        _vm._l(_vm.optGrNumbers, function(data) {
                          return _c(
                            "a-select-option",
                            { key: data.key, attrs: { value: data.value } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s(data.label) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s(data.label) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "label-align": "left",
                        label: _vm.$t(_vm.formRules.supplierName.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.supplierName.decorator,
                              expression: "formRules.supplierName.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.supplierName.name,
                            placeholder: _vm.$t(
                              _vm.formRules.supplierName.placeholder
                            ),
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loadingdatalistsupplierName,
                            allowClear: true
                          },
                          on: {
                            search: function(value) {
                              return _vm.getListContact(value)
                            }
                          }
                        },
                        _vm._l(_vm.datalistSupplierName, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.firstName } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(
                                      " " + _vm._s("" + data.firstName) + " "
                                    )
                                  ]),
                                  _vm._v(
                                    " " + _vm._s("" + data.firstName) + " "
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "label-align": "left",
                        label: _vm.$t(_vm.formRules.branch.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.branch.decorator,
                              expression: "formRules.branch.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.branch.name,
                            placeholder: _vm.$t(
                              _vm.formRules.branch.placeholder
                            ),
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loadingBranch,
                            allowClear: true
                          },
                          on: {
                            search: function(value) {
                              return _vm.getBranch(value)
                            },
                            change: _vm.handleBranch
                          }
                        },
                        _vm._l(_vm.dataBranch, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.id } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s(data.name) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s(data.name) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "label-align": "left",
                        label: _vm.$t(_vm.formRules.warehouse.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.warehouse.decorator,
                              expression: "formRules.warehouse.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.warehouse.name,
                            placeholder: _vm.$t(
                              _vm.formRules.warehouse.placeholder
                            ),
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loadingdatalistLocation,
                            allowClear: true
                          },
                          on: {
                            search: function(value) {
                              return _vm.getListOfWarehouseLocation(value)
                            },
                            change: _vm.handleLocation
                          }
                        },
                        _vm._l(_vm.datalistLocation, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.id } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s("" + data.name) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s("" + data.name) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "label-align": "left",
                        label: _vm.$t(_vm.formRules.rack.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.rack.decorator,
                              expression: "formRules.rack.decorator"
                            }
                          ],
                          attrs: {
                            placeholder: _vm.$t(_vm.formRules.rack.placeholder),
                            name: _vm.formRules.rack.name,
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loadingdatalistLocationRack,
                            allowClear: true
                          },
                          on: {
                            search: function(value) {
                              return _vm.getListOfWarehouseLocationRack(value)
                            }
                          }
                        },
                        _vm._l(_vm.datalistLocationRack, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.id } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s("" + data.name) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s("" + data.name) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t(_vm.formRules.poNumber.label) } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: _vm.formRules.poNumber.decorator,
                            expression: "formRules.poNumber.decorator"
                          }
                        ],
                        attrs: {
                          name: _vm.formRules.poNumber.name,
                          placeholder: _vm.$t(
                            _vm.formRules.poNumber.placeholder
                          ),
                          autocomplete: "off"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t(_vm.formRules.productCategory.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.productCategory.decorator,
                              expression: "formRules.productCategory.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.productCategory.name,
                            placeholder: _vm.$t(
                              _vm.formRules.productCategory.placeholder
                            ),
                            showSearch: true,
                            "filter-option": false,
                            loading: _vm.loadingCategory,
                            allowClear: true
                          },
                          on: {
                            search: function(value) {
                              return _vm.getListOfProductCategory(
                                "search=name~*" + value + "*"
                              )
                            }
                          }
                        },
                        _vm._l(_vm.dataListCategory, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.id } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s("" + data.name) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s("" + data.name) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t(_vm.formRules.receiveDateFrom.label)
                      }
                    },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: _vm.formRules.receiveDateFrom.decorator,
                            expression: "formRules.receiveDateFrom.decorator"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          placeholder: _vm.$t(
                            _vm.formRules.receiveDateFrom.placeholder
                          ),
                          format: _vm.DEFAULT_DATE_FORMAT
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: _vm.$t(_vm.formRules.receiveDateTo.label)
                      }
                    },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: _vm.formRules.receiveDateTo.decorator,
                            expression: "formRules.receiveDateTo.decorator"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          placeholder: _vm.$t(
                            _vm.formRules.receiveDateTo.placeholder
                          ),
                          format: _vm.DEFAULT_DATE_FORMAT
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t(_vm.formRules.status.label) } },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRules.status.decorator,
                              expression: "formRules.status.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRules.status.name,
                            placeholder: _vm.$t(
                              _vm.formRules.status.placeholder
                            ),
                            "option-filter-prop": "children",
                            "filter-option": _vm.filterOption,
                            allowClear: true,
                            "show-search": ""
                          }
                        },
                        _vm._l(_vm.datalistStatus, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.value } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s("" + data.value) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s("" + data.value) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: [16, 16] } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-space",
                    [
                      _c("a-button", { on: { click: _vm.clearItems } }, [
                        _vm._v(" " + _vm._s(_vm.$t("lbl_reset")) + " ")
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.loadingTable,
                            "html-type": "submit"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_find")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.$can("create", "inventory-receive")
                ? _c(
                    "a-col",
                    { attrs: { span: 12, align: "end" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "logistic.goods-receipt-checklist.create"
                            }
                          }
                        },
                        [
                          _c("a-button", { attrs: { type: "primary" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("lbl_create_new")) + " ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          "data-source": _vm.dataListItems,
          columns: _vm.columnsTable,
          loading: _vm.loadingTable,
          pagination: {
            showTotal: function() {
              return _vm.$t("lbl_total_items", { total: _vm.totalData })
            },
            total: _vm.totalData,
            showSizeChanger: true,
            current: _vm.page
          },
          size: "small",
          scroll: { x: "calc(100% + 500px)" }
        },
        on: { change: _vm.onChangeTable },
        scopedSlots: _vm._u([
          {
            key: "number",
            fn: function(text) {
              return _c("span", {}, [_vm._v(_vm._s(_vm._f("qty")(text)))])
            }
          },
          {
            key: "date",
            fn: function(text) {
              return _c("span", {}, [_vm._v(_vm._s(_vm._f("date")(text)))])
            }
          },
          {
            key: "nullable",
            fn: function(text) {
              return _c("span", {}, [_vm._v(_vm._s(text || "-"))])
            }
          },
          {
            key: "operation",
            fn: function(text, record) {
              return [
                _c(
                  "a-dropdown",
                  { attrs: { trigger: ["click"], placement: "bottomCenter" } },
                  [
                    _c("a-button", {
                      attrs: { icon: "bars" },
                      on: {
                        click: function(e) {
                          return e.preventDefault()
                        }
                      }
                    }),
                    _c(
                      "a-menu",
                      {
                        staticClass: "mt-2",
                        attrs: { slot: "overlay" },
                        slot: "overlay"
                      },
                      [
                        _vm.allowEdit(record.status) &&
                        _vm.$can("update", "inventory-receive")
                          ? _c(
                              "a-menu-item",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name:
                                          "logistic.goods-receipt-checklist.edit",
                                        params: { id: record.receivingId }
                                      }
                                    }
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "edit" } }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("lbl_edit")) + " "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "a-menu-item",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name:
                                          "logistic.goods-receipt-checklist.detail",
                                        params: { id: record.receivingId }
                                      }
                                    }
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "eye" } }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("lbl_view")) + " "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "expandedRowRender",
            fn: function(record2) {
              return _c(
                "a-descriptions",
                {
                  attrs: {
                    bordered: "",
                    layout: "vertical",
                    column: 6,
                    size: "small"
                  }
                },
                [
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: _vm.$t("lbl_brand") } },
                    [_vm._v(" " + _vm._s(record2.productMerk || "-") + " ")]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: _vm.$t("lbl_type") } },
                    [_vm._v(" " + _vm._s(record2.type || "-") + " ")]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: _vm.$t("lbl_capacity") } },
                    [_vm._v(" " + _vm._s(record2.capacity || "-") + " ")]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: _vm.$t("lbl_specification") } },
                    [_vm._v(" " + _vm._s(record2.specification || "-") + " ")]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: _vm.$t("lbl_serial_number") } },
                    [_vm._v(" " + _vm._s(record2.serialNumber || "-") + " ")]
                  ),
                  _c(
                    "a-descriptions-item",
                    { attrs: { label: _vm.$t("lbl_created_by") } },
                    [_vm._v(" " + _vm._s(record2.createdBy || "-") + " ")]
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "text-right mt-2" },
        [
          _c(
            "a-space",
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingDownload },
                  on: { click: _vm.download }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_download")) + " ")]
              ),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.loadingPrint },
                  on: { click: _vm.print }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_print")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }